import { render, staticRenderFns } from "./show-info-item.vue?vue&type=template&id=66c8df6a&scoped=true&"
import script from "./show-info-item.vue?vue&type=script&lang=ts&"
export * from "./show-info-item.vue?vue&type=script&lang=ts&"
import style0 from "./show-info-item.vue?vue&type=style&index=0&id=66c8df6a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c8df6a",
  null
  
)

export default component.exports